import type { FullUserProfile } from 'types'
import store from './store'

export const users = store<{ [key: string]: FullUserProfile }>({})
